'use strict';

(function($) {

    var pluginName = 'kumsalGallery';

    // plugin setup
    $.fn[pluginName] = function(options) {
        if ($(this).length === 0) {
            return;
        }

        // global variables
        var gallery = this;


        var Plugin = {
            options: {
                min: 0,
                max: 0,
                inputName:'',
                multiple:false,
                image: true,
                video: false,
            },
            isInit: false,
            gallery: null,
            dropzone: null,
            isSingle: false,
            addError: function(fileName,message) {
                gallery.find('.kumsal-gallery-error').append(
                    "<div class=\"alert alert-solid-danger alert-bold\" role=\"alert\">\n" +
                    "   <div class=\"alert-text\"><b>"+fileName+":</b> "+message+"</div>\n" +
                    "   <div class=\"alert-close\">\n" +
                    "       <button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">\n" +
                    "           <span aria-hidden=\"true\"><i class=\"la la-close\"></i></span>\n" +
                    "       </button>\n" +
                    "   </div>\n" +
                    "</div>\n"
                );
            },
            delete: function (button,translate) {

                swal.fire({
                    title: translate.title,
                    text: translate.text,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: translate.buttons.confirm,
                    cancelButtonText: translate.buttons.cancel,
                    showLoaderOnConfirm: true,
                    allowOutsideClick: function() {
                        return !swal.isLoading();
                    },
                    preConfirm: function () {
                        return new Promise(function (resolve) {
                            $.ajax({
                                url: $(button).attr('href'),
                                type: 'POST',
                                data: {
                                    '_method' : 'DELETE'
                                }
                            }).always(function(status) {
                                if(typeof status.status === 'boolean' && status.status)
                                {
                                    swal.fire({
                                        type: 'success',
                                        title: translate.success.title,
                                        html: translate.success.text,
                                        confirmButtonText: _translation.datatable.buttons.okey,
                                    });

                                    if (!gallery.options.multiple)
                                    {
                                        gallery.dropzone[0].dropzone.files=[];
                                    }

                                    $(button).parents('.dz-preview').remove();

                                    gallery.calculateSingleGallery();
                                }
                                else
                                {
                                    swal.fire({
                                        type: 'error',
                                        title: _translation.datatable.action.failed.title,
                                        html: _translation.datatable.action.failed.text,
                                        confirmButtonText: _translation.datatable.buttons.okey,
                                    });
                                }
                            })
                        })
                    },
                }).then(function(result){

                    if (result.dismiss === 'cancel') {

                        swal.fire({
                            type: 'error',
                            title: _translation.datatable.action.cancel.title,
                            html: _translation.datatable.action.cancel.text,
                            confirmButtonText: _translation.datatable.buttons.okey,
                        });
                    }
                });

            },
            editFile:function(button){
                $(button).kumsalAction(Object.assign({}, $(button).data(),{
                    formData: {
                        translation:$(button).parents('.kumsal-gallery-container').data('translation'),
                        language:$(button).parents('.kumsal-gallery-container').data('language')
                    }
                }));
            },
            initFancybox: function() {
                $(document).on('click','[data-fancybox]', function(){
                    $(this).fancybox({
                        selector: '.gallery-fancybox[data-fancybox='+$(this).attr('data-fancybox').split("[").join("\\[").split("]").join("\\]")+']',
                        protect: true,
                    });
                });
            },
            initActions: function() {

                gallery.on("click", ".dropzone-media-delete", function(e) {
                    e.preventDefault();
                    gallery.delete(this,_translation.datatable.delete);
                });

                gallery.on('click','.kumsal-gallery-edit',function (event) {
                    event.preventDefault();
                    gallery.editFile(this);
                });
            },
            initSortable: function() {

                Sortable.create(gallery.dropzone[0], {
                    filter: '.openfilemanager',
                    handle: '.dz-image',
                    onMove: function (e) {
                        return e.related.className.indexOf('openfilemanager') === -1;
                    },
                    multiDrag: true,
                    selectedClass: 'selected',
                    animation: 150,
                    group: gallery.options.multiple ? 'gallery' : null,
                    onEnd: function (e) {
                        $.each(e.items, function(index,item){
                            $(item).find('.media-id').attr('name',$(e.to).parents('.kumsal-gallery-container').attr('data-input-name')+"[]");
                            $(item).find('.gallery-fancybox').attr('data-fancybox',$(e.to).parents('.kumsal-gallery-container').attr('data-input-name'));
                        });
                        $(e.item).find('.media-id').attr('name',$(e.to).parents('.kumsal-gallery-container').attr('data-input-name')+"[]");
                        $(e.item).find('.gallery-fancybox').attr('data-fancybox',$(e.to).parents('.kumsal-gallery-container').attr('data-input-name'));
                    },
                });
            },
            calculateSingleGallery: function()
            {
                !gallery.options.multiple && gallery.dropzone.find('.dz-preview:not(.openfilemanager)').length ?
                    gallery.dropzone.find('.dz-preview.openfilemanager').addClass('d-none') :
                    gallery.dropzone.find('.dz-preview.openfilemanager').removeClass('d-none');
            },
            initCropper: function(){
                gallery.on('click','.kumsal-media-cropper', function(){

                    options = {};

                    var sizes = {
                        width: gallery.options.width,
                        height: gallery.options.height,
                    };

                    options.aspectRatio = sizes.width/sizes.height;

                    if(options.aspectRatio){
                        $(this).kumsalCropper(options);
                    }
                });
            },
            initDropzone: function(){

                if (!gallery.isInit)
                {
                    gallery.dropzone = $(gallery).children('.kumsal-gallery-dropzone');

                    Dropzone.autoDiscover = false;

                    var acceptedFiles = [];

                    if(gallery.options.image){
                        acceptedFiles.push('image/*');
                    }
                    if(gallery.options.video){
                        acceptedFiles.push('video/mp4');
                    }


                    var dropzoneOptions = {
                        url: _route['admin.dropzone.store'],
                        headers: {
                            'x-csrf-token': $('meta[name="csrf-token"]').attr('content'),
                        },
                        maxFiles: gallery.options.multiple ? (gallery.options.max ? gallery.options.max : null ) : 1,
                        paramName: 'image',
                        maxFilesize: _config.upload_max_filesize / 1000000,
                        timeout: _config.dropzone_timeout * 1000,
                        thumbnailWidth: 250,
                        thumbnailHeight: null,
                        parallelUploads:4,
                        clickable: '#' + gallery.find('.openfilemanager').attr('id'),
                        acceptedFiles: acceptedFiles.join(','),
                        dictDefaultMessage: _translation.dropzone.message.dictDefaultMessage,
                        dictFallbackMessage: _translation.dropzone.message.dictFallbackMessage,
                        dictFallbackText: _translation.dropzone.message.dictFallbackText,
                        dictFileTooBig: _translation.dropzone.message.dictFileTooBig,
                        dictInvalidFileType: _translation.dropzone.message.dictInvalidFileType,
                        dictCancelUpload: _translation.dropzone.message.dictCancelUpload,
                        dictUploadCanceled: _translation.dropzone.message.dictUploadCanceled,
                        dictCancelUploadConfirmation: _translation.dropzone.message.dictCancelUploadConfirmation,
                        dictRemoveFile: _translation.dropzone.message.dictRemoveFile,
                        dictRemoveFileConfirmation: _translation.dropzone.message.dictRemoveFileConfirmation,
                        dictMaxFilesExceeded: _translation.dropzone.message.dictMaxFilesExceeded,
                        processing: function()
                        {
                            gallery.calculateSingleGallery();
                        },
                        accept: function(file, done,don)
                        {
                            if (this.options.maxFiles != null && (this.getAcceptedFiles().length + gallery.dropzone.find('.dz-page-init').length) >= this.options.maxFiles) {
                                done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
                                return this.emit("maxfilesexceeded", file);
                            } else {
                                done();
                            }
                        },
                        success: function(file, response, xhr) {
                            $(file.previewElement).append('<input type="hidden" name="'+ gallery.attr('data-input-name') +(gallery.options.multiple ? '[]' : '') +'" value="'+response.id+'">');
                            $(file.previewElement).find('.dz-details').html(response.buttons);
                            $(file.previewElement).find('.dz-image img').attr('src',response.thumb);
                            $(file.previewElement).find('.gallery-fancybox').attr('href',response.original);
                            $(file.previewElement).find('.gallery-fancybox').attr('data-fancybox',gallery.attr('data-input-name'));
                            gallery.calculateSingleGallery();
                        },
                        error: function(file, response , xhr) {
                            var message = _translation.somethingWentWrong;

                            if (typeof xhr !== 'undefined' && xhr.status === 422)
                            {
                                try
                                {
                                    var errors = [];

                                    $.each(Object.entries(response.errors), function( index, value ) {
                                        errors = errors.concat(value[1]);
                                    });

                                    message = errors.join('<br>');
                                }catch (e) {}
                            }
                            if (typeof xhr !== 'undefined' && xhr.status === 413)
                            {
                                message = this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize);
                            }
                            if (typeof xhr === 'undefined' && typeof response === 'string' &&  response !== '')
                            {
                                message = response;
                            }

                            gallery.addError(file.name,message);

                            //remove uploaded item
                            this.removeFile(file);
                            gallery.calculateSingleGallery();
                        },
                        maxfilesreached: function()
                        {
                            /*if (!gallery.options.multiple && this.files >= 2)
                            {
                                this.removeFile(this.files[0])
                                gallery.calculateSingleGallery();
                            }*/
                            //
                        },
                        maxfilesexceeded: function(file)
                        {
                            if (!gallery.options.multiple)
                            {
                                gallery.find('.kumsal-gallery-error').children().last().remove();
                                this.removeAllFiles();
                                console.log(gallery.find('.dz-preview:not(.openfilemanager)'))
                                gallery.find('.dz-preview:not(.openfilemanager)').remove();
                                this.addFile(file);
                                gallery.calculateSingleGallery();
                                gallery.find('.kumsal-gallery-error').children().last().remove();
                            }
                            return false;
                        },
                        init: function() {
                            if (gallery.options.multiple)
                            {
                                gallery.initSortable();
                            }
                        }
                    };

                    gallery.dropzone.dropzone(jQuery.extend(dropzoneOptions));

                    gallery.calculateSingleGallery();

                    gallery.isInit = true;

                }
            },
            init: function()
            {
                gallery.options = gallery.data();

                gallery.initDropzone();
                gallery.initActions();
                gallery.initFancybox();
                gallery.initCropper();

                return gallery;
            },
        };

        /**
         * Public API methods can be used directly by datatable
         */
        $.each(Plugin, function(funcName, func) {
            gallery[funcName] = func;
        });

        if (!gallery.isInit){
            gallery.init();
        }

        return gallery;
    };

}(jQuery));

$('document').ready(function () {
    $(".kumsal-gallery-container").each(function( index ) {
        $(this).kumsalGallery();
    });
});